export enum ActionItemType {
  MenuItem = 0,
  PrimaryItem,
}
